"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSliderSprings = void 0;
const react_1 = __importDefault(require("react"));
const react_spring_1 = require("react-spring");
const clamp_1 = require("./utils/clamp");
function useSliderSprings({ offsetRef, slideWidth, sliderWidth, totalSlideCount, visibleSlideCount, immediate }) {
    const getSpringProps = react_1.default.useCallback((index, relativeDelta = 0) => {
        const hidden = immediate
            ? visibleSlideCount === 1 && index !== offsetRef.current
            : false;
        const visibility = hidden ? 'hidden' : 'visible';
        const baseX = offsetRef.current * slideWidth;
        const x = baseX + relativeDelta * sliderWidth;
        const clampedX = (0, clamp_1.clamp)(x, baseX - slideWidth / 2, baseX + slideWidth / 2);
        return {
            from: { x: baseX, visibility },
            x: clampedX,
            visibility,
            immediate,
            config: { tension: 250 }
        };
    }, [offsetRef, slideWidth, sliderWidth, visibleSlideCount, immediate]);
    const [springs, setSpringProps] = (0, react_spring_1.useSprings)(totalSlideCount, index => getSpringProps(index));
    return [
        springs,
        react_1.default.useCallback(relativeDelta => {
            setSpringProps(index => getSpringProps(index, relativeDelta));
        }, [setSpringProps, getSpringProps])
    ];
}
exports.useSliderSprings = useSliderSprings;
